import { Controller } from "@hotwired/stimulus"
import { getSavedTheme, setTheme, syncThemeBadge } from "../theme"

export default class extends Controller {
    static targets = ["toggle", "label", "button"]

    connect() {
        this.syncUi(getSavedTheme())
        this.onThemeChange = this.onThemeChange.bind(this)
        document.addEventListener("emailpa:themechange", this.onThemeChange)
    }

    disconnect() {
        document.removeEventListener("emailpa:themechange", this.onThemeChange)
    }

    onThemeChange(event) {
        this.syncUi(event.detail.theme)
    }

    toggle(event) {
        // The toggle sits inside the General settings form; without this its
        // change would bubble to the form's change->autosave#submit and fire a
        // no-op /settings.json POST + a spurious "Settings saved" toast. Theme
        // persists client-side, not on the setting. (Same-element actions like
        // toggle-badge#update still run — this only stops the ancestor form.)
        event?.stopPropagation()
        const isDark = event.target.type === "checkbox"
            ? event.target.checked
            : getSavedTheme() !== "dark"
        const next = isDark ? "dark" : "light"
        setTheme(next)
        syncThemeBadge(isDark)
        this.syncUi(next)
    }

    syncUi(theme) {
        const isDark = theme === "dark"
        if (this.hasToggleTarget) {
            this.toggleTarget.checked = isDark
        }
        if (this.hasLabelTarget) {
            this.labelTarget.textContent = isDark ? "Light" : "Dark"
        }
    }
}
